const LoginStyles = theme => ({
  paper: {
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(2),
      // Keep FREE SIGN UP close to the form so a phone needs less scrolling.
      marginBottom: 0,
      '@media (max-height: 750px)': {
        margin: theme.spacing(1),
        marginBottom: 0
      }
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  desktopLoginwrapper: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    },
    marginBottom: theme.spacing(3)
  },
  avatar: {
    backgroundColor: '#3966f8'
  },
  logindetails: {
    marginBottom: theme.spacing(1.5),
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: '#ffffff',
      transition: 'all 0.2s ease-in-out',
      '& fieldset': {
        borderColor: '#e2e8f0',
        transition: 'all 0.2s ease-in-out'
      },
      '&:hover fieldset': {
        borderColor: '#b4c6fc'
      },
      '&.Mui-focused': {
        boxShadow: '0 0 0 3px rgba(57, 102, 248, 0.12)'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3966f8',
        borderWidth: '2px'
      }
    }
  },
  inputBase: {
    fontSize: 'inherit'
  },
  input: {
    height: '20px'
  },
  inputLabel: {
    transform: 'translate(14px, 16px) scale(1)',
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -8px) scale(0.75)'
    }
  },
  form: {
    width: '100%',
    maxWidth: '550px',
    zIndex: 1,
    background: '#ffffff',
    borderRadius: '16px',
    padding: '36px 40px',
    boxShadow: '0 10px 30px rgba(57, 102, 248, 0.05)',
    border: '1px solid rgba(57, 102, 248, 0.08)',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 20px 10px',
      marginBottom: 0,
      borderRadius: '12px',
      '@media (max-height: 750px)': {
        padding: '16px 16px 8px'
      }
    }
  },
  submit: {
    margin: theme.spacing(2, 0, 1, 0),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(2, 0, 1, 0),
      '@media (max-height: 750px)': {
        margin: theme.spacing(1, 0, 0.5, 0)
      }
    },
    fontSize: '18px',
    fontWeight: '600',
    textTransform: 'none',
    borderRadius: '12px',
    height: '48px',
    background: 'var(--my-gradient)',
    boxShadow: '0 4px 14px 0 rgba(57, 102, 248, 0.25)',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 6px 20px 0 rgba(57, 102, 248, 0.35)'
    },
    '&:active': {
      transform: 'translateY(0px)'
    }
  },
  signupButton: {
    fontSize: '18px',
    fontWeight: '600',
    textTransform: 'none',
    padding: '10px 24px',
    minWidth: '233px',
    borderRadius: '12px',
    background: 'var(--my-gradient)',
    boxShadow: '0 4px 14px 0 rgba(57, 102, 248, 0.25)',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 6px 20px 0 rgba(57, 102, 248, 0.35)'
    },
    '&:active': {
      transform: 'translateY(0px)'
    }
  },
  otcButton: {
    height: 48,
    borderRadius: '12px',
    textTransform: 'none',
    fontWeight: '600',
    [theme.breakpoints.down('sm')]: {
      height: 40
    }
  },
  bottomWrapper: {
    zIndex: 1,
    width: '100%',
    [theme.breakpoints.down('md')]: {
      marginTop: 'auto',
      paddingBottom: theme.spacing(4),
      '@media (max-height: 750px)': {
        paddingBottom: theme.spacing(2)
      }
    }
  },
  revisionTag: {
    position: 'fixed',
    top: '8px',
    left: '8px',
    zIndex: 9999,
    fontSize: '10px',
    color: 'rgba(0, 0, 0, 0.45)',
    pointerEvents: 'none',
    fontFamily: 'monospace',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  }
});

export default LoginStyles;
